import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';

import {Manage} from './Views/Manage';
import {Preview} from './Views/Preview/Preview';
import {UserContextProvider} from 'Contexts/UserContext/UserContext';
import {OpenAiTokenContextProvider} from 'Contexts/OpenAiTokenContext';
import {Styleguide} from 'Views/Styleguide';
import {PageContainer} from 'Components/PageContainer';
import {SignIn} from 'Components/Auth/SignIn';
import {NotFound} from 'Components/NotFound';
import {ToastHandler} from 'Components/ToastHandler';
import {RouteContainer} from 'Components/RouteContainer';
import {Dashboard} from 'Views/Dashboard';
import {CodeConfig} from 'Views/CodeConfig';
import {ProjectPage} from 'Views/ProjectPage';

export default function App() {
    return (
        <Router>
            <OpenAiTokenContextProvider>
                <UserContextProvider>
                    <div>
                        <Switch>
                            <Route path="/" exact>
                                <RouteContainer protectedRoute>
                                    <Dashboard />
                                </RouteContainer>
                            </Route>
                            <Route path="/success" exact>
                                <Redirect to="/manage" />
                            </Route>
                            <Route path="/publish/:id*" exact>
                                <Preview mode="Publish" />
                            </Route>
                            <Route path="/project/:projectId">
                                <RouteContainer protectedRoute>
                                    <ProjectPage />
                                </RouteContainer>
                            </Route>
                            <Route path="/login" exact>
                                <PageContainer>
                                    <SignIn />
                                </PageContainer>
                            </Route>
                            <Route path="/manage" exact>
                                <RouteContainer protectedRoute requirePaid>
                                    <Manage />
                                </RouteContainer>
                            </Route>
                            <Route path="/styleguide" exact>
                                <RouteContainer requirePaid protectedRoute>
                                    <Styleguide />
                                </RouteContainer>
                            </Route>
                            <Route path="/tailwindconfig" exact>
                                <RouteContainer requirePaid protectedRoute>
                                    <CodeConfig />
                                </RouteContainer>
                            </Route>
                            <Route>
                                <PageContainer ignoreLoading>
                                    <NotFound />
                                </PageContainer>
                            </Route>
                        </Switch>
                    </div>
                    <ToastHandler />
                </UserContextProvider>
            </OpenAiTokenContextProvider>
        </Router>
    );
}
